import "./atoms-v21241.js";
import "./atoms-v21242.js";
var e = function(r) {
  return function(a, n, t) {
    return t !== void 0 ? r(a, n, t) : function(u) {
      return r(a, n, u);
    };
  };
}, p = function(r, a, n) {
  return Math.min(Math.max(n, r), a);
}, c = e(p), o = function(r, a, n) {
  var t = a - r;
  return ((n - r) % t + t) % t + r;
}, v = e(o);
c(0, 1);
export {
  c as clamp,
  v as wrap
};
